"use strict";

const ReportingTimelineController = function () {
  let annualReportingSettings = null;
  let allAnnualReports = [];

  var init = function (currentAnnualReports) {
    if (Session.isRegulator()) return;
    allAnnualReports = currentAnnualReports;

    loadDataListeners();
  };

  var render = function () {
    load();
    handleShown();
  };

  var handleShown = function (activeTab = Tree.get("activeTab")) {
    if (activeTab === "todo") {
      show(updateHeights);
    } else {
      hide(updateHeights);
    }
  };

  var updateHeights = function () {
    MapFunctions.setMapHeight();
  };

  var loadDataListeners = function () {
    Tree.select("activeTab").on("update", (e) => handleShown(e.data.currentData));
  };

  var load = function () {
    const reportingDataGroup = DataViewFunctions.getCurrentDataViewProperty("reportingDataGroup");
    annualReportingSettings = allAnnualReports.find(
      (report) => report.dataName === reportingDataGroup,
    );

    if (annualReportingSettings) {
      ScheduleTickerTimeline.loadTimeline();
      ScheduleTickerTimeline.setTimeline("#main-header-collapse-container");
      MapFunctions.setMapHeight();
    } else {
      console.warn(`No "reportingDataGroup" configured for the current data view.`);
    }
  };

  var show = function () {
    if (annualReportingSettings === null) {
      hide();
      return;
    }
    $(".ticker-container").show();
  };

  var hide = function () {
    $(".ticker-container").hide();
  };

  var getAnnualReportSettings = function () {
    return annualReportingSettings;
  };

  return {
    init,
    show,
    hide,
    getAnnualReportSettings,
    handleShown,
    render,
  };
};

module.exports = ReportingTimelineController();

const Tree = require("./tree");
const DataViewFunctions = require("./dataViewFunctions");
const ScheduleTickerTimeline = require("./scheduleTickerTimeline");
const MapFunctions = require("./mapFunctions/mapFunctions");
const Session = require("./login/session");
